import React from 'react';
import './Impress.css';

class Impress extends React.Component {
  render() {
    return (
      <div className="impress">
        <div className="impress-padding">
            <h2 className="impress-h2">Impressum</h2>
            Tanzband Red Lines GbR<br/>
            Edith-Stein-Straße 34<br/>
            48683 Ahaus<br/>
            <br/>

            <h3 className="impress-h3">Vertreten durch</h3>
            Jan Rensing <br/>
            Simon Hassels <br/>
            Moritz Meier <br/>
            Michael Ostendorf <br/>
            <br/>

            <h3 className="impress-h3">Kontakt</h3>
            E-Mail: red-lines@googlegroups.com<br/>
            Telefon: +49 171 2914642<br/>
            <br/>

            <h3 className="impress-h3">Website Design</h3>
            Jan Rensing <br/>
            <br/>
        </div>
      </div>
    )
  }
}

export default Impress;


// WEBPACK FOOTER //
// ./src/components/impress/Impress.js